import { Link } from "react-router-dom";

export function BoltMark({ className = "w-4 h-4" }) {
  return (
    <svg viewBox="0 0 24 24" className={className} fill="currentColor" aria-hidden="true">
      <path d="M13 2 3 14h7l-1 8 11-14h-8l1-6z" />
    </svg>
  );
}

export default function Logo() {
  return (
    <Link to="/" data-testid="logo-link" className="group flex items-center gap-2.5">
      <span className="grid h-9 w-9 place-items-center rounded-xl border border-voltaic-line bg-voltaic-elevated text-voltaic-cyan transition-colors duration-300 group-hover:border-voltaic-cyan group-hover:glow-cyan">
        <BoltMark />
      </span>
      <span className="font-display text-lg font-extrabold tracking-[0.22em]">VOLTAIC</span>
    </Link>
  );
}
